import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-close",
  "use": "svg-icon-close-usage",
  "viewBox": "0 0 384.15 384.15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384.15 384.15\" id=\"svg-icon-close\"><path fill=\"currentColor\" d=\"m373.58 322.68-130.6-130.6 130.6-130.6c14.1-14.1 14.1-36.8 0-50.9s-36.8-14.1-50.9 0l-130.6 130.6-130.6-130.6c-14.1-14.1-36.8-14.1-50.9 0s-14.1 36.8 0 50.9l130.6 130.6-130.6 130.6c-14.1 14.1-14.1 36.8 0 50.9s36.8 14.1 50.9 0l130.6-130.6 130.6 130.6c14.1 14.1 36.8 14.1 50.9 0 14-14.1 14-36.9 0-50.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol